// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderCalendar_container__8XOkD","calendar":"OrderCalendar_calendar__XidFE"};